import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import axios from 'axios';


const CreateProduct = () => {

    const loginState = useSelector(state => state.currentLogin); //consolidated new Redux login state
    const messageState = useSelector(state => state.message);

    const [name, setName] = useState('');  //local hooks
    const [imageName, setImageName] = useState('');  //local hooks
    const [mapLink, setMapLink] = useState('');  //local hooks
    const [phone, setPhone] = useState('');  //local hooks
    const [waitingTime, setWaitingTime] = useState('');  //local hooks
    const [category, setCategory] = useState('');  //local hooks
    const [price, setPrice] = useState('');  //local hooks
    const [description, setDescription] = useState('');  //local hooks
    const dispatch = useDispatch();  //Assign useDispatch so we can use it...

    const dataPost = {
        name: name,
        imageName: imageName,
        mapLink: mapLink,
        phone: phone,
        waitingTime: waitingTime,
        category: category,
        price: price,
        description: description
    }

    useEffect(() => {
        console.log('[*] {Test CreateProduct} Redux loginState -> [userid]: ', loginState.userid, '  [isLoggedIn]: ', loginState.isLoggedIn, '  [username]: ', loginState.username, '  [firstName]: ', loginState.firstName, '  [lastName]: ', loginState.lastName, '  [token]: ', loginState.token);
        const fetchProductDetail = async () => {
            await axios
            .get(`/product/find/2`, { headers: {Authorization: loginState.token} })
            .then(response => {
                console.log('[*] {Test CreateProduct}', response.data);
                //dispatch(allProducts(response.data));
            })
            .catch((err) => {
                console.log('❌ ProductDetail: ', err);
            });
        };
        fetchProductDetail();
    }, [loginState]);  //run everytime the productId changes...

    const submitProduct = () => {
        console.log('---- Posting new Product...');
        //axios.post('/product/createrecord', dataPost, { headers: {Authorization: `${localStorage.getItem('token')}`} })
        axios.post('/product/createrecord', dataPost, { headers: {Authorization: loginState.token} })
        .then(res => {
            //console.log('00000 Going into res get data ... 00000');
            //dispatch(sysmessage('Product added successfully...'));  //Set successful message...
            dispatch({ type: 'SYSMESSAGE', message: 'Product added successfully...', messageType: 'alert alert-success' });
            //console.log('----- Pure res.data -----');
            console.log(res.data);
            //-> Should we also set this data into redux state???
        }).catch(err => {
            console.log(err.response);
            //dispatch(sysmessage(err.response.data.message)); //set error message to redux state sysmessage...
            dispatch({ type: 'SYSMESSAGE', message: err.response.data.message, messageType: 'alert alert-danger' });
        });
    }

    let printMessage = '';
    if(messageState.message){
        //console.log('----- SYSMESSAGE Called...');
        printMessage = (
            <div className={messageState.messageType} role="alert">
                {messageState.message}
            </div>
        )
    }
    
    return(
        <>
            <div className="container" style={{ marginTop: 50 }}>
            <div className="form-product-create">

                    <h3>Create Product</h3>
                    {printMessage}
                    <div className="form-floating">
                        <input type="name" className="form-control" placeholder="Dish Name" 
                            onChange={event => setName(event.target.value)} />
                        <label>Dish Name</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="imageName" className="form-control" placeholder="Image Name" 
                            onChange={event => setImageName(event.target.value)} />
                        <label>Image Name (url**)</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="mapLink" className="form-control" placeholder="Map Link" 
                            onChange={event => setMapLink(event.target.value)} />
                        <label>Map Link (url**)</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="phone" className="form-control" placeholder="Phone" 
                            onChange={event => setPhone(event.target.value)} />
                        <label>Phone</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="waitingTime" className="form-control" placeholder="Waiting Time (Mins)" 
                            onChange={event => setWaitingTime(event.target.value)} />
                        <label>Waiting Time (Mins)</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="category" className="form-control" placeholder="Eg. Western, Asian, etc..." 
                            onChange={event => setCategory(event.target.value)} />
                        <label>Food Category</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="price" className="form-control" placeholder="Price (S$)" 
                            onChange={event => setPrice(event.target.value)} />
                        <label>Price</label>
                    </div>
                    <br />

                    <div className="form-floating">
                        <input type="description" className="form-control" placeholder="Description (give more details...)" 
                            onChange={event => setDescription(event.target.value)} />
                        <label>Description</label>
                    </div>
                    <br />

                    <button className="btn btn-primary" onClick={() => submitProduct()}>Submit Product</button>
            </div>
            </div>
        </>
    )
}
export default CreateProduct;
